import {Component, HostListener, OnInit} from '@angular/core';
import {ForgetPasscodeComponent} from "@app/channels/auth/login/partials/forget-passcode/forget-passcode.component";
import {ScreenManagerService} from "@mpt-fo/common/core/services/screen-manager.service";
import {SettingsService} from "@mpt-fo/common/core/services/settings.service";
import {OnboardingV2Service} from "@mpt-fo/common/core/services/onboarding-v2.service";
import {ModalService} from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";
import {AppConfig} from "@mpt-fo/common/shared/config/app-config";
import {LoginHelperService} from "@mpt-fo/common/core/services/login-helper.service";
import {LocalStorageService} from "@mpt-fo/common/core/services/local-storage.service";
import {
  ForgetPasswordTimelinesViaPhonenumber,
  ForgetPasswordTimelinesViaPhonenumber2FAOrderByLiveliness,
  ForgetPasswordTimelinesViaPhonenumber2FAOrderByOTP,
  ForgetPasswordTimelinesViaUsername,
  ForgetPasswordTimelinesViaUsername2FAOrderByLiveliness,
  ForgetPasswordTimelinesViaUsername2FAOrderByOTP,
  PasswordRecoveryStep,
  PasswordRecoveryStep2FAOrderByLiveliness,
  PasswordRecoveryStep2FAOrderByOTP
} from "@app/channels/auth/login/model/forget-passcode";
import {TimelineModel} from "@mpt-fo/common/shared/models/timeline.model";
import {IdentityProvider} from "@mpt-fo/common/kamona/model/kamonal-model";
import {LivelinessService} from "@mpt-fo/common/core/services/liveliness.service";
import {AuthenticationService} from "@mpt-fo/common/core/services/authentication.service";
import {ProfileSetupService} from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import { AuthenticationType2FA } from '@mpt-fo/common/shared/models/authentication-method.enum';
import { DataLayerService } from '@mpt-fo/common/core/services/data-layer-service.service';
import { DeviceHelperService } from '@mpt-fo/common/core/services/device-helper.service';
import { LocationHelper } from '@mpt-fo/common/core/helpers/location.helper';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent extends ForgetPasscodeComponent implements OnInit {
  timelines = ForgetPasswordTimelinesViaPhonenumber;
  usernameTimelines = ForgetPasswordTimelinesViaUsername;
  invalidPasscodeTitle = 'Invalid Password';
  passwordTimeline: TimelineModel;
  invalidPasscodeMessage = 'New Password must be the same as confirm password';
  SubmittingDescription = 'Changing Password'
  SuccessTitle = 'Your Password Has Been Changed!';
  SuccessDescription = 'Your Password Has Been Changed successfully';
  RecoveryStep = PasswordRecoveryStep as any;
  LIVELINESS_PURPOSE = 'PASSWORD_RESET';
  otpPurpose = 'RECOVER_PASSWORD';
  ID_VERIFICATION_URL = '/api/v1/settings/password-recovery';
  ID_VERIFICATION_META_MAP = '/api/v1/settings/password-recovery';
  ID_VERIFICATION_URL_V2 = '/api/v1/settings/face-match';
  IdentityProvider = IdentityProvider;
  recoveryType = 'password';
  redirectUrl = '/login/forget-passcode';
  verificationType = '';
  twoOrderByLiveliness = false;
  isLivelinessVerificationDone = false;

  constructor(
      screenManagerService: ScreenManagerService,
      public settingsService: SettingsService,
      public modalHelper: OnboardingV2Service,
      modalService: ModalService,
      public config: AppConfig,
      loginHelper: LoginHelperService,
      localStorage: LocalStorageService,
	  livelinessService: LivelinessService,
	  authService: AuthenticationService,
	  profileService: ProfileSetupService,
		deviceHelper: DeviceHelperService,
    dataLayerService: DataLayerService,locationHelper: LocationHelper,){
      super(screenManagerService, settingsService,
		modalHelper, modalService,
		config, loginHelper, localStorage, livelinessService, authService, profileService, deviceHelper, dataLayerService, locationHelper);
  }

  ngOnInit(): void {
    this.RecoveryStep = PasswordRecoveryStep as any;
    super.ngOnInit();
  }

  setUrl(){
    if (this.is2FAEnabled) {
      this.ID_VERIFICATION_URL = this.ID_VERIFICATION_URL_V2;
      this.ID_VERIFICATION_META_MAP = this.ID_VERIFICATION_URL_V2;
    }
  }

  setCurrentStep(step: PasswordRecoveryStep){
    this.currentStep = step;
  }

	setStepAfterEnteredIDCredential(){
		this.otpTimeline = this.findTimelineByStep(this.RecoveryStep.PHONE_VERIFICATION);
		const value = this.userTypePayload?.value;
		const params = this.usePhoneNumberForRecovery ? {phoneNumber: value} : {username: value};
		this.updateTimelineWithFormData(params, PasswordRecoveryStep.ENTER_PASSWORD_RECOVERY);
		this.setCurrentStep(this.RecoveryStep.PHONE_VERIFICATION);
	}
	loadingOtp: boolean;
  generateOtp()
  {
    this.submitting = true;
    this.settingsService.generatePasswordOTP(this.buildOtpGenerationPayload())
        .then((res) => {this.handleOtpGenerationResponse(res);})
        .catch((error)=> {this.handleFailedOtpGeneration(error)})
        .finally(() =>{
			this.submitting = false
		});
  }

	getIdVerificationPayloadValue(){
		const timelineData = this.getTimelineDataByStep(PasswordRecoveryStep.ENTER_PASSWORD_RECOVERY);
		const value = this.usePhoneNumberForRecovery ? timelineData?.phoneNumber : timelineData?.username;
		return value;
	}

  setPhoneNumberRecoveryTimelines() {
    if (this.twoOrderByLiveliness) {
      this.setTimelinesAndSteps(ForgetPasswordTimelinesViaPhonenumber2FAOrderByLiveliness, PasswordRecoveryStep2FAOrderByLiveliness, PasswordRecoveryStep2FAOrderByLiveliness.LIVELINESS);
    } else {
      this.setTimelinesAndSteps(ForgetPasswordTimelinesViaPhonenumber2FAOrderByOTP, PasswordRecoveryStep2FAOrderByOTP, PasswordRecoveryStep2FAOrderByOTP.PHONE_VERIFICATION);
    }
  }

  setUsernameRecoveryTimelines() {
    if (this.twoOrderByLiveliness) {
      this.setTimelinesAndSteps(ForgetPasswordTimelinesViaUsername2FAOrderByLiveliness, PasswordRecoveryStep2FAOrderByLiveliness, PasswordRecoveryStep2FAOrderByLiveliness.LIVELINESS);
    } else {
      this.setTimelinesAndSteps(ForgetPasswordTimelinesViaUsername2FAOrderByOTP, PasswordRecoveryStep2FAOrderByOTP, PasswordRecoveryStep2FAOrderByOTP.PHONE_VERIFICATION);
    }
  }

  setTimelinesAndSteps(timelines: any, passcodeRecoveryStep: any, currentStep: any) {
    this.timelines = timelines;
    this.PasscodeRecoveryStep = passcodeRecoveryStep;
    this.RecoveryStep = passcodeRecoveryStep;
    this.setCurrentStep(currentStep);
    this.markasCompletedAndActiveTimeline(currentStep);
  }

  handleOtpValidationResponse(validationKey: string, otp: string) {
    const data = { otp, validationKey };
    const nextKey = this.determineNextKey(data);

    if (!this.reference || !this.ussdCode) {
      this.generate2FA();
    }

    this.updateTimelines(nextKey, data);
    this.setCurrentStep(nextKey);
  }

  determineNextKey(data: any): PasswordRecoveryStep {
    if (this.isUsing2FAFlow()) {
      return this.getNextKeyFor2FAFlow(data);
    } else {
      return this.getNextKeyWithout2FAPassword(data);
    }
  }

  isUsing2FAFlow(): boolean {
    return this.is2FAEnabled && this.verificationType === AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION;
  }

  getNextKeyFor2FAFlow(data: any) {
    const isOtpCompleted = this.isStepCompleted(this.RecoveryStep.PHONE_VERIFICATION);

    if (this.isLivelinessVerificationDone) {
      return this.getNextKeyWhenLivelinessDone(data, isOtpCompleted);
    } else {
      this.updateTimelineWithFormData(data, this.RecoveryStep.PHONE_VERIFICATION);
      return this.RecoveryStep.LIVELINESS;
    }
  }

  getNextKeyWhenLivelinessDone(data: any, isOtpCompleted: boolean) {
    const nextKey = isOtpCompleted ? this.RecoveryStep.ENTER_PASSWORD : this.RecoveryStep.PHONE_VERIFICATION;
    this.updateTimelineWithFormData(data, nextKey - 1);
    return nextKey;
  }

  getNextKeyWithout2FAPassword(data: any) {
    this.updateTimelineWithFormData(data, PasswordRecoveryStep.PHONE_VERIFICATION);
    return PasswordRecoveryStep.ENTER_PASSWORD;
  }

  updateTimelines(nextKey: PasswordRecoveryStep, data: any) {
    if (this.is2FAEnabled) {
      this.markasCompletedAndActiveTimeline(nextKey);
    } else {
      this.updateOtpTimeline();
    }
    this.setStepThreeTimeline();
  }


  buildPayloadToResetPasscode(): any{
    const timelineTimelineData = this.getTimelineDataByStep(PasswordRecoveryStep.ENTER_PASSWORD_RECOVERY);
    const idTimelineData = this.getTimelineDataByStep(this.RecoveryStep.PHONE_VERIFICATION);
    const passcodeTimelineData = this.getTimelineDataByStep(this.RecoveryStep.ENTER_PASSWORD);
    const value = this.usePhoneNumberForRecovery ? timelineTimelineData?.phoneNumber : timelineTimelineData?.username;
    const password = passcodeTimelineData?.password;
    const payload = {password, validationKey: idTimelineData?.validationKey};
    return this.usePhoneNumberForRecovery ? {...payload, phoneNumber: value} : {...payload, username: value};
  }

  buildPayloadToResetPasscodeV2(): any{
    const deviceInformation = this.settingsService.getDeviceInformation();
    const timelineTimelineData = this.getTimelineDataByStep(PasswordRecoveryStep.ENTER_PASSWORD_RECOVERY);
    const idTimelineData = this.getTimelineDataByStep(this.RecoveryStep.PHONE_VERIFICATION);
    const passcodeTimelineData = this.getTimelineDataByStep(this.RecoveryStep.ENTER_PASSWORD);
    const idTimelineDataLiveliness2Fa = this.getTimelineDataByStep(this.RecoveryStep.LIVELINESS);
    const value = this.usePhoneNumberForRecovery ? timelineTimelineData?.phoneNumber : timelineTimelineData?.username;
    const password = passcodeTimelineData?.password;
    const twoFAPayloadLiveliness = this.shouldSendReference() ? { reference: idTimelineDataLiveliness2Fa?.validationKey || this.reference } : {};
    const payload = {
      newPassword: password, otpValidationKey: this.ussdCode ? idTimelineData?.validationKey : null,
      authenticationPurpose: this.LIVELINESS_PURPOSE, ...twoFAPayloadLiveliness, deviceId: deviceInformation?.deviceUniqueIdentifier
    };
    return this.usePhoneNumberForRecovery ? {...payload, phoneNumber: value} : {...payload, username: value};
  }

  shouldSendReference(){
    return this.is2FAEnabled && this.isLivelinessVerificationDone && !!this.reference;
  }

  submitPasswordWeb({oldPassword, newPassword}){
    const passwordData = {password: oldPassword};
    const confirmPasscodeData = {confirmPassword: newPassword};
    this.updateTimelineWithFormData(passwordData, this.RecoveryStep.ENTER_PASSWORD);
    this.updateTimelineWithFormData(confirmPasscodeData, this.RecoveryStep.CONFIRM_PASSWORD);
    this.handleConfirmedPassCodeTimeline();
    this.submitPasscode(oldPassword,newPassword);
  }

	proceedToLiveliness(){
		this.setCurrentStep(this.RecoveryStep?.PHONE_VERIFICATION);
	}

  handlePasscodeReset(){
    this.submitting = true;
    this.openInProgressModal();
    const payload = this.is2FAEnabled ? this.buildPayloadToResetPasscodeV2() : this.buildPayloadToResetPasscode();
    const apiCall = this.is2FAEnabled ? this.settingsService.changePasswordV2(payload) : this.settingsService.changePassword(payload);
    apiCall.then((res) => {this.handlePasscodeResponse(res?.message)})
        .catch((error) => {this.handleFailedOtpGeneration(error);})
        .finally(() => this.submitting = false);
  }


  validateOtp($event: any) {
    this.submitting = true;
    this.settingsService.validatePasswordOTP(this.buildValidateOtpPayload( $event?.otp))
        .then((res) => {this.handleOtpValidationResponse(res?.validationKey, $event?.otp);})
        .catch(error => {this.handleFailedOtpGeneration(error)})
        .finally(() => {this.submitting = false;})
  }

  setStepThreeTimeline(){
    this.passwordTimeline = this.settingsService.findTimelineByStep(this.timelines, this.RecoveryStep.ENTER_PASSWORD);
  }

	updateIdVerificationTimelineWithLiveliness(){
		this.timelines.forEach( timeline => {
			if(timeline.step === this.RecoveryStep.PHONE_VERIFICATION){
				timeline.title = 'Verify ID Information';
			}
		})
	}

  verificationUrl(){
    this.setUrl();
    return `${this.config.MONIEPOINT_USER_URL}${this.ID_VERIFICATION_URL}/${this.reference}/status?livenessPurpose=${this.LIVELINESS_PURPOSE}`;
  }

  get is2FAEnabled(){
    return this.config.USE_2FA_FLOW_FORGOT_PASSWORD;
  }

  get isWhatsAppEnabled() {
    return this.config.USE_OTP_WHATSAPP_FORGOT_PASSWORD;
  }
}
